import React, { useState, useEffect } from "react";
import Layout from "components/structure/Layout";
import ImportList from "../Common/ImportList";

const ImportFT = () => {
  return (
    <Layout title={"Import FT"}>
      <ImportList entityName="ImportFTFAMapping" displayName="Import FT To FA Mapping" />
    </Layout>
  );
};

export default ImportFT;
